<script setup lang="ts">
import { ref, useRoute, useRouter, useToast, useUser } from "#imports";
import { isTrue } from "~/components/forms/validation";

import MPCheckbox from "~/components/forms/MPCheckbox.vue";
import MPButton from "~/components/forms/MPButton.vue";

const router = useRouter();
const route = useRoute();
const userStore = useUser();
const { showError } = useToast();

const privacyPolicyAccepted = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);

const handlePrivacyPolicy = async () => {
  try {
    isSubmitting.value = true;
    await userStore.submitPrivacyPolicy();
    const redirect =
      typeof route.query.redirect === "string" ? route.query.redirect : "/";
    await router.push(redirect);
  } catch (e) {
    showError("Unable to save privacy policy", e);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <div class="privacy-container">
    <h4>Before you can continue, please agree to the privacy policy</h4>
    <div class="privacy-policy">
      <form @submit.prevent="handlePrivacyPolicy">
        <div>
          <MPCheckbox
            v-model="privacyPolicyAccepted"
            name="privacyPolicyAccepted"
            label="I agree to the"
            :validate="
              (v) => (isTrue(v) ? 'Privacy policy is required' : undefined)
            "
          >
            <template #helpText>
              <NuxtLink to="/info/privacy-policy" target="_blank"
                >Privacy Policy</NuxtLink
              >
            </template> </MPCheckbox
          ><br />
        </div>
        <MPButton
          type="submit"
          label="Submit"
          :isLoading="isSubmitting"
          :disabled="isSubmitting"
        />
      </form>
    </div>
  </div>
</template>
<style lang="postcss" scoped>
.privacy-container {
  padding: 2rem;

  h4 {
    text-align: center;
  }
}

.privacy-policy {
  position: relative;
  display: grid;
  align-items: center;
  justify-items: center;
  gap: 0.5rem;
  font-size: var(--font-size-9);

  span {
    position: absolute;
    top: 50%;
    right: -1.5rem;
    transform: translate(-50%, -50%);
    color: var(--color-slate-500);
    background-color: var(--color-slate-50);
    padding: 0.25rem 0.25rem;
    border-radius: 0.25rem;
    cursor: pointer;
  }

  form {
    button {
      margin: auto;
    }
  }
}
</style>
